import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import TimeSector from 'common/components/elements/time-sector';
import DateFormatter from 'common/utils/DateFormatter';
import './style.scss';
import TruncateText from 'common/components/elements/truncate-text';
import { MediaButtonWrapper, MediaButton } from "common/components/modules/media";

const HeaderInfo = ({
   title,
   date,
   handleClose,
   fixed,
   hideAfterMinutes,
   position,
   isAdmin,
}) => {
   let hasTimeOut = false;
   let timeSector = null
   let timeDifference = null
   if(!!hideAfterMinutes){
      hasTimeOut = true
      const result = DateFormatter.storyDate(date, hideAfterMinutes)
      timeSector = result.sector
      timeDifference = result.time;
   }
   const storyDate = hideAfterMinutes ? timeDifference : 'Published ' +  moment(`${ date }+00`).fromNow()
   return (
      <div
         className={ classnames({
            'w-full h-auto font-sans header-gradient z-10': true,
            'fixed top-0': fixed,
            [position]: position,
         }) }
      >
         <div
            className='flex justify-between'
         >
            {
               (hasTimeOut || isAdmin || title) && (

                  <div
                     style={ {
                        maxWidth: 'calc(50% - 52px)',
                     } }
                     className='px-2 pt-2 text-major-dark flex flex-col'>
                     {
                        title && (
                           <MediaButtonWrapper
                              isCenter={ false }
                           >
                              <TruncateText
                                 // width='calc(100% - 32px)'
                                 text={ title }
                                 // notranslate-content-title
                                 textClass='text-xl font-bold leading-[24px] notranslate'
                                 textSize='20px'
                                 fontWeight='700'
                              />
                           </MediaButtonWrapper>

                        )
                     }
                     {
                        (hasTimeOut || isAdmin) && (
                           <MediaButtonWrapper isCenter={ false } className='mt-2 flex items-center'>
                              {hasTimeOut && <TimeSector angle={ timeSector } />}
                              { isAdmin && <span className='text-sm text-major-dark'> {storyDate}</span>}
                           </MediaButtonWrapper>
                        )
                     }
                  </div>
               )
            }
            {
               handleClose && (
                  <div
                     className='ml-auto mx-3 mt-2'
                  >
                     <MediaButton
                        iconName='close'
                        onClick={ (e) => {
                           handleClose(e);
                        } }
                     />
                  </div>
               )
            }
         </div>
      </div>
   );
};

HeaderInfo.defaultProps = {
   showTimeLeft: false,
   fixed: false,
};

HeaderInfo.propTypes = {
   title: PropTypes.string,
   date: PropTypes.string,
   hideAfterMinutes: PropTypes.number,
   fixed: PropTypes.bool,
   handleClose: PropTypes.func,
   position: PropTypes.string,
   isAdmin: PropTypes.bool,
};

export default memo(HeaderInfo);
